module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"fieldobligatory":"Field obligatory"},"fr":{"fieldobligatory":"Champs obligatoire"}}')
  delete Component.options._Ctor
}
